import React from "react";
import { CounterpartyCreationResponse } from "@common/contracts/counterparty.contract";
import { CreateCounterpartyAddressBody } from "@common/schemas/counterpartyAddress.schema";
import { CreateCounterpartyContactBody } from "@common/schemas/counterpartyContact.schema";
import { ModalComponentWithResultProps } from "@helpers/modal";
import {
    StandardModalBody,
    StandardModalHeader,
} from "@design-system/Modal/Modal";
import { COUNTERPARTY_EDITOR_CREATE_FORM_ID } from "@components/settings/Directory/CounterpartyEditor/counterpartyEditorFormIds";
import { CounterpartyEditorDrawerCreate } from "@components/settings/Directory/CounterpartyEditor/CounterpartyEditorDrawerCreate";
import { CounterpartyFormFields, FormSchema } from "./CounterpartyForm";

interface Props extends ModalComponentWithResultProps<CounterpartyCreationResponse> {
    forTransactionEditing?: boolean;
    initialValues?: Partial<FormSchema>;
    seedContacts?: CreateCounterpartyContactBody[];
    seedAddresses?: CreateCounterpartyAddressBody[];
    title?: string;
    fields?: CounterpartyFormFields;
}

export const CreateCounterpartyModal: React.FC<Props> = ({
    close,
    forTransactionEditing,
    initialValues,
    seedContacts,
    seedAddresses,
    title = "Create counterparty",
    fields = "company",
}) => (
    <>
        <StandardModalHeader>{title}</StandardModalHeader>
        <StandardModalBody className="pb-0">
            <CounterpartyEditorDrawerCreate
                onCreated={close}
                onCancelled={close}
                initialValues={initialValues}
                seedContacts={seedContacts}
                seedAddresses={seedAddresses}
                fields={fields}
                forTransactionEditing={forTransactionEditing}
                formId={COUNTERPARTY_EDITOR_CREATE_FORM_ID}
                footer="form"
            />
        </StandardModalBody>
    </>
);
